import React from "react";
import "./errorBoundary.css";
import { MdError } from "react-icons/md";
import Button from "react-bootstrap/Button";
import { withRouter } from "react-router-dom";
import Logger from "../../utils/Logger";
import { reportReactError } from "../../utils/errorReporter";

class ErrorBoundary extends React.Component {
  state = { hasError: false, errorInfo: {} };

  constructor(props) {
    super(props);
    const { history } = props;
    history.listen((location, action) => {
      if (this.state["hasError"]) {
        this.setState({
          hasError: false,
        });
      }
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.errorInfo !== this.props.errorInfo) {
      console.log("global error info ", this.props.errorInfo);

      this.setState({ errorInfo: this.props.errorInfo, hasError: true });
      Logger.log(
        window.location.pathname,
        "Error caught by Error boundary at " + window.location.pathname,
        true,
        this.props.errorInfo.toString()
      );
    }
  }

  // Update state so the next render will show the fallback UI
  static getDerivedStateFromError(error) {
    console.log("getDerivedStateFromError");
    return { hasError: true };
  }

  // Log error details
  componentDidCatch(error, info) {
    console.log("componentDidCatch", error);
    console.log("this.props.caughtAt", this.props.caughtAt);
    window.errorHandledByBoundary = true;
    this.setState({
      errorInfo: error,
    });
    Logger.log(
      window.location.pathname,
      "Error caught by Error boundary at " + window.location.pathname,
      true,
      error.toString()
    );
    /* Send to backend telemetry. Async, fire-and-forget; the
       reporter handles dedup / throttle / sanitization. */
    try {
      reportReactError(error, info, this.props.caughtAt);
    } catch (e) {
      console.log("reportReactError failed", e);
    }
  }

  render() {
    if (this.state.hasError) {
      // Render fallback UI
      return (
        <div class="error-boundary-div fade-in-up">
          <div class="header">
            <MdError className="error-boundary-icon" />
            <div class="title">
              {this.props.localizedText["something-went-wrong"]}
            </div>
            <div class="sub-title">
              {this.props.localizedText["reloading-may-solve-this-issue"]}
            </div>
            <Button
              className="primary-button outside-primary-button"
              onClick={() => {
                window.location.reload();
              }}
            >
              {this.props.localizedText["reload"]}
            </Button>
          </div>
          <div class="support-page-link">
            {this.props.localizedText["for-help-please-go-to-our"]}&nbsp;
            <l>{this.props.localizedText["support-page"]}</l>
          </div>
          {process.env.REACT_APP_ENV != "prod" ? (
            <div class="error-detail">
              Error: &nbsp;
              <div class="detail">
                {this.state.errorInfo.message
                  ? this.state.errorInfo.message
                  : null}
              </div>
            </div>
          ) : null}
          {process.env.REACT_APP_ENV != "prod" ? (
            <div class="error-detail">
              Caught At: &nbsp;
              <div class="detail">
                {this.props.caughtAt ? this.props.caughtAt : "undefined"}
              </div>
            </div>
          ) : null}
        </div>
      );
    }

    // Render children if no error
    return this.props.children;
  }
}

export default withRouter(ErrorBoundary);
